import React from 'react';
import {styled} from '@mui/material';

const Holder = styled('div')(({theme}) => ({
  display: 'flex',
  borderRadius: 4,
  fontFamily: theme.typography['fixedWidth'],
  fontWeight: '700',
  padding: '2px 4px',

  '&.high': {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
  },

  '&.medium': {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.warning.contrastText,
  },

  '&.low': {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.success.contrastText,
  }
}));

const TaskPriority = ({task}) => (
  <Holder className={task.priority.toLowerCase()}>
    {task.priority === 'High' ? '!!!' : (task.priority === 'Medium' ? <>!!&nbsp;</> : <>!&nbsp;&nbsp;</>)}
  </Holder>
);

export default TaskPriority;
